import type { SerializedStyles } from "@emotion/react";
import { css } from "@emotion/react";

import { theme } from "shared/lib/styles/theme";

export const autoCollapseAdSlotStyles = css`
  inline-size: 1px;
  block-size: 1px;
  min-inline-size: 1px;
  max-inline-size: 1px;
  min-block-size: 1px;
  max-block-size: 1px;
  margin: 0;
  padding: 0;

  border: none;

  background-color: transparent;
`;

export const applyStylesOnSlotCollapsed = (styles?: SerializedStyles) => css`
  :has([data-slot-collapse="true"]) {
    ${theme.breakpoints.down("desktop")} {
      ${styles ?? autoCollapseAdSlotStyles}
    }
  }
`;

export const applyStylesOnSlotReady = (styles?: SerializedStyles) => css`
  :has([data-slot-ready="true"]) {
    ${theme.breakpoints.down("desktop")} {
      ${styles ?? null}
    }
  }
`;
